import { Injectable } from '@angular/core';

@Injectable()
export class DateService {

  constructor() { }

  inputFormat = function (date) {

    let yyyy = date.getUTCFullYear();
    let mm = date.getUTCMonth() < 9 ? "0" + (date.getUTCMonth() + 1) : (date.getUTCMonth() + 1);
    let dd = date.getUTCDate() < 10 ? "0" + date.getUTCDate() : date.getUTCDate();

    return `${yyyy}-${mm}-${dd}`;
  }

  myDateFormatted(date) {
    let dateToFormat = new Date(date);
    let yyyy = dateToFormat.getFullYear();
    let mm = dateToFormat.getMonth() < 9 ? "0" + (dateToFormat.getMonth() + 1) : (dateToFormat.getMonth() + 1);
    let dd = dateToFormat.getDate() < 10 ? "0" + dateToFormat.getDate() : dateToFormat.getDate();

    return `${dd}/${mm}/${yyyy}`
  }

  reverse = function (date) {
    let splitted_date = date.split('/');
    return splitted_date[1] + '/' + splitted_date[0] + '/' + splitted_date[2];
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/date.service.ts